'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellRootContext } from './context/upsell-root.context';
import { upsellHeaderRecipe } from './styles/upsell-header.styles';
import type { UpsellHeaderPropsInterface } from './types/upsell-header.types';

/**
 * @since 10.0.0
 */
export const UpsellHeader = forwardRef<HTMLDivElement, UpsellHeaderPropsInterface>(
  (props: UpsellHeaderPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellRootContext);
    const styles = css(upsellHeaderRecipe.raw({ tone }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Upsell.Header"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellHeader.displayName = 'Upsell.Header';
